<template>
    <v-layout justify-left>
        <v-container fluid grid-list-md class="category-card-container">
            <v-layout row wrap>
                <v-flex v-for="(card, index) in cards" :key="index" md2 xs6>
                    <v-card hover router :to="card.link"
                            class="fixed-size-vcard">
                        <v-container pa-2 class="category-name">
                            <v-layout class="category-headline-layout">
                                <v-flex xs12 align-end flexbox>
                                    <span class="category-headline-text" v-text="card.title"></span>
                                </v-flex>
                            </v-layout>
                        </v-container>

                        <v-container fill-height pa-2 class="category-image">
                            <v-layout row wrap align-center>
                                <v-flex class="text-xs-center">
                                    <img :src="getImgUrl(card.image)">
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
                <v-flex md2 xs6>
                    <v-card hover class="fixed-size-vcard">
                        <v-container fill-height class="addmore-card-image">
                            <v-layout row wrap align-end>
                                <v-flex class="text-xs-center">
                                    <img src="../assets/15addmore.png">
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <v-container class="addmore-card-name">
                            <v-layout>
                                <v-flex xs12 align-end flexbox>
                                    <span class="category-headline-text">Add new</span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-layout>
</template>

<script>
    export default {
        props: ['cards'],
        methods: {
            getImgUrl(img) {
                var image = require.context('../assets/', false, /\.svg$/)
                return image('./' + img + ".svg")
            },
            getOrder(card, index) {
                return 'order-xs' + (index + 1) + ' order-md' + (index + 1) + `xs${card.flex}` + `md${card.flex}`;
            },
        },
        data() {
            return {}
        }
    }
</script>
<style>
    .category-card-container {
        padding: 0 0 1rem 0 !important;
    }

    .category-name {
        height: 25%;
    }

    .category-headline-layout {
        text-align: left;
    }

    .category-headline-text {
        font-size: 16px;
        font-weight: 600;
        letter-spacing: normal;
        line-height: 32px;
    }

    .category-image {
        height: 75% !important;
    }

    .addmore-card-name {
        padding: 0 !important;
        height: 40%;
    }

    .addmore-card-image {
        padding: 0 !important;
        height: 60% !important;
    }

    .fixed-size-vcard {
        height: 100%;
        width: 100%;
        margin-left: 1%;
        margin-bottom: 1%;
    }

    .category-image img {
        max-width: 100%
    }
</style>
